<template>
  <div>
    <van-popup
      :value="show"
      position="bottom"
      style="height: 50%; overflow: hidden;"
      @click-overlay="hidePopup"
    >
      <div style="position: absolute; width: 100%; z-index: 1; background-color: #fff;">
        <div class="poi-search">
          <van-search
            v-model="query"
            placeholder="请输入门店名称"
            @input="onSearch"
            @search="onSearch"
          />
        </div>
      </div>
      <div style="height: calc(100% - 50px); padding-top: 55px; overflow: auto;">
        <long-list
          ref="longList"
          class="info-panel"
          :api-method="getPoi"
          :response-handler="getPoiHandler"
        >
          <template #default="{list}">
            <van-cell
              v-for="item in list"
              :key="item.poiId"
              :title="item.poiName"
              :title-class="[poiId === item.poiId?'active':'']"
              @click="onClickPoi(item)"
            >
              <template #right-icon>
                <van-icon
                  :class="[poiId === item.poiId?'active':'', 'right-icon']"
                  name="success"
                />
              </template>
            </van-cell>
          </template>
        </long-list>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import Api from '@/api/marketing';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    poiId: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      query: '',
    };
  },
  created() {
    this.onSearch = debounce(this.search, 200);
  },
  methods: {
    search() {
      this.$refs.longList.reset();
      this.$refs.longList.request(1);
    },
    async getPoi(pageNum, pageSize) {
      const res = await Api.getTradeDataPoiList(this.query, pageNum, pageSize);
      return res;
    },
    getPoiHandler(res) {
      const { error, data } = res;
      if (!error && data) {
        return {
          totalCount: data.total,
          list: data.list,
        };
      } else {
        return undefined;
      }
    },
    onClickPoi(poi) {
      this.$emit('select', poi);
      this.hidePopup();
    },
    hidePopup() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.active {
  color: #1989fa;
}
.right-icon {
  visibility: hidden;
  &.active{
    visibility: visible;
  }
}
</style>
